import _ from 'lodash'
import React from 'react'
import app from '../../../app.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import PlannerPageProvider from '../../../lib/planner_pageprovider.jsx'
import Grid from '../../../theme/grid/grid/grid.jsx'
import DateRangePicker from '../../common/daterange_picker/daterange_picker.jsx'
import PageHeaderTask from '../../layout/page_headertask/page_headertask.jsx'
import PageDetail from '../../page/page_detail/page_detail.jsx'
import { getDataTasks } from './page_task_utils.js'
import timerStates from '../../../../shared/util/timer/timerStates.js'
import { buildTimerEvents } from '../../../../shared/util/timer/timerEvents.js'
import { TasksIcon } from '../../../common/layout/menu_icons/tasks.jsx'

class PageTaskMain extends PageDetail {
  _taskDataGetter = null

  constructor (props) {
    super(props, 'task', 'task', 'task')

    this.data = {
      pageState: {
        filters: [],
        visibleObjects: ['task'],
        filter: {
          contactIds: [],
          projectIds: [],
          userIds: [],
          fromDate: null,
          toDate: null
        },
        expandObjectIds: null
      },
      stat: {},
      histories: [],
      tasks: [],
      project: this.props.project,
      projects: [],
      users: [],
      skillOptions: [],
      currentEditObject: null,
      activeTask: null,
      showProjectInfo: true,
      fromDate: null,
      toDate: null,
      editTaskId: props.editTaskId,
      initialUserId: app.loggedInId
    }

    this._references = {
      sidebarTask: React.createRef(),
      pageHeaderCalendar: React.createRef(),
      uploadErrorDialog: React.createRef()
    }

    this.activeDate = props.date
      ? new Date(props.date)
      : DateUtil.getUTCCurrentDate()
    this._updateWeekNo(this.activeDate)
    this._calculateFromToDates(this.activeDate)

    this._taskDataGetter = getDataTasks(app)({
      active: true,
      $client: {
        subObjects: {
          user: ['firstName', 'lastName', 'skills', 'image'],
          project: ['title', 'contactId'],
          contact: ['company'],
          commentUser: ['firstName', 'lastName', 'image', 'userId']
        }
      }
    })
  }

  static get propTypes () {
    return {}
  }

  static get defaultProps () {
    return {}
  }

  componentDidMount () {
    this._initializeUserFilters()
    this._getData(false)
    this._initEvents()

    if (this.props.showAddTask) {
      return this._onAddTask(null)
    }
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  getContentClassname () {
    return 'alt'
  }

  canShowCollapse () {
    return true
  }

  _initializeUserFilters () {
    const { pageState } = this.data
    const filters = pageState.filters || []

    // Initially remove all assignee filters for first time
    _.remove(filters, item => item.ident === 'assignee')

    // Add logged in user as default assignee
    const userId = app.loggedInId
    filters.unshift({
      ident: 'assignee',
      typeLabel: IntlUtil.convertMessage('common.newfilter.lableIdentAssignee'),
      value: userId,
      text: app.loggedInUserTeam.displayName
    })

    pageState.filters = filters

    if (pageState.filter) {
      pageState.filter.userIds = [userId]
    } else {
      pageState.filter = { userIds: [userId] }
    }
  }

  /* Data functions */
  _getData (_bReload) {
    const { fromDate, toDate, initialUserId } = this.data

    let filterFromDate = null
    let filterToDate = null

    if (this.activeDate) {
      const currDate = this.activeDate
      filterFromDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth(),
        currDate.getDate()
      )
      filterToDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth(),
        currDate.getDate() + 1
      )
    }

    const params = {
      query: {
        pageIdent: this._pageIdent,
        taskStat: {
          userId: [],
          fromDate: fromDate,
          toDate: toDate
        },
        $client: {
          task: {
            active: true
          },
          initialState: {
            fromDate: filterFromDate,
            toDate: filterToDate,
            userId: initialUserId,
            filters: initialUserId ? this.data.pageState.filters : []
          },
          getHeaderStat: true,
          getUser: true
        },
        user: {
          teamId: app.getTeamId(),
          $select: ['userId', 'firstName', 'lastName'],
          status: 'active'
        }
      }
    }

    // Pass the initiail user id only one time
    this.data.initialUserId = null

    app
      .service('/api/page/plannertask')
      .find(params)
      .then(taskRes => {
        this._onPageDataRecieved(taskRes.pageData)
        this.data.pageState = taskRes.pageState
        this.data.tasks = taskRes.tasks || []
        this.data.histories = taskRes.histories || []

        if (taskRes.projectOptions) {
          this.data.projects = taskRes.projectOptions || []
        }

        if (taskRes.skillOptions) {
          this.data.skillOptions = taskRes.skillOptions || []
        }

        if (taskRes.stat) {
          this.data.stat = taskRes ? taskRes.stat : null
        }

        if (taskRes.users) {
          this.data.users = taskRes.users || []
        }

        if (this.data.tasks) {
          if (
            this.data.pageState.expandObjectIds === null ||
            this.data.pageState.expandObjectIds === undefined
          ) {
            const expandObjectIds = []
            this.data.tasks.forEach(task => {
              expandObjectIds.push(task.id)
            })

            this.data.pageState.expandObjectIds = expandObjectIds
          }
        }
        this._onDataReceived(null)
      })
      .catch(err => {
        this._onDataReceived(err)
      })
  }

  _reloadData () {
    this._getData(true)
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageTask: _onDataReceived Error', err)
      this.setState({ dataDate: new Date() })
    } else {
      app.debug('PageTask: _onDataReceived [done]')
      this.setState({ dataDate: new Date() })

      if (this.data.editTaskId) {
        const editTask = _.find(
          this.data.tasks,
          task => task.id === this.data.editTaskId
        )
        if (editTask) {
          this._onEditTask(editTask, false)
        }

        this.data.editTaskId = null
      }
    }
  }

  /* Realtime Events */
  _eventReloadTask (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageTask - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _updateWeekNo (activeDate) {
    if (activeDate.getDay() === 0) {
      const date = DateUtil.addDaysToDate(activeDate, -1)
      this.weekNo = DateUtil.getLocalWeekNo(date)
      this.year = date.getFullYear()
    } else {
      this.weekNo = DateUtil.getLocalWeekNo(activeDate)
      this.year = activeDate.getFullYear()
    }
  }

  _calculateFromToDates (activeDate) {
    this.activeDate = activeDate

    const filter = this.data.pageState.filter
    if (this.activeDate && filter) {
      const currDate = this.activeDate

      filter.fromDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth(),
        currDate.getDate()
      )
      filter.toDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth(),
        currDate.getDate() + 1
      )
    }

    this.data.fromDate = DateUtil.getMondayByDate(activeDate)
    this.data.toDate = DateUtil.addDaysToDate(this.data.fromDate, 6)
    this.data.toDate.setHours(23, 59, 59, 59)
  }

  async _getDataTasks (onDataReceived) {
    const response = await this._taskDataGetter(this.data.pageState.filter,
      this.activeDate
    )
    if (response.data) {
      this.data.tasks = response.data
    }
    onDataReceived(null)
  }

  _createOrUpdateTask (task) {
    const timer = this._getTimer()
    const timerEvents = buildTimerEvents(app)

    if (timer.doesRelateToTaskId(task.id)) {
      timer.resume(app)
    } else {
      const createObj = {
        userId: this.data.userId,
        projectId: task.projectId,
        activityId: task.activityId,
        taskId: task.id,
        timeCardId: null,
        status: timerStates.STARTED
      }

      timerEvents.createTimer(createObj)
    }
  }

  _initEvents () {
    this._initTimerEvents(this._onReloadTimer.bind(this))

    this._eventHandlers.taskCreated = this._eventReload.bind(
      this,
      'Task',
      'Created'
    )
    this._eventHandlers.taskUpdated = this._eventReload.bind(
      this,
      'Task',
      'Updated'
    )
    this._eventHandlers.taskRemoved = this._eventReload.bind(
      this,
      'Task',
      'Removed'
    )
    this._eventHandlers.taskPatched = this._eventReload.bind(
      this,
      'Task',
      'Patched'
    )

    const taskService = app.service('/api/project/plannertask')
    taskService.on('created', this._eventHandlers.taskCreated)
    taskService.on('updated', this._eventHandlers.taskUpdated)
    taskService.on('removed', this._eventHandlers.taskRemoved)
    taskService.on('patched', this._eventHandlers.taskPatched)
  }

  _releaseEvents () {
    this._releaseTimerEvents()

    const taskService = app.service('/api/project/plannertask')
    taskService.off('created', this._eventHandlers.taskCreated)
    taskService.off('updated', this._eventHandlers.taskUpdated)
    taskService.off('removed', this._eventHandlers.taskRemoved)
    taskService.off('patched', this._eventHandlers.taskPatched)

    this._eventHandlers.taskCreated = null
    this._eventHandlers.taskUpdated = null
    this._eventHandlers.taskRemoved = null
    this._eventHandlers.taskPatched = null
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()

      if (this.data.activeTask) {
        this._createOrUpdateTask(this.data.activeTask)
        this.data.activeTask = null
      }
    }
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()
    }
  }

  /* Render functions */
  renderContent () {
    const { tasks } = this.data

    return (
      <div className='pagecontentwrap'>
        {this._renderGridFilter()}
        <Grid>
          {this._renderTaskGridHeader()}
          <div className='cgrid-content tasklist'>
            {/* @TODO :
            - populate this hardcoded value with actual value based on activity status
            - in scope of the ticket ROD-561 I added this change so the behavior is like before we show always the icons
             */}
            {tasks.map(task =>
              this._renderTaskItem(
                { ...task, activityIsActive: true },
                false,
                false,
                true
              )
            )}
          </div>
        </Grid>
        {this._renderTimecardDetail()}
        {this._renderDialogConfirm()}
      </div>
    )
  }

  renderRightSidebar () {
    const { projects, skillOptions } = this.data
    return this._renderRightSidebarTask(projects, skillOptions)
  }

  /* Header Functions - START */
  renderHeader () {
    const { stat, fromDate, toDate } = this.data
    const weekNo = DateUtil.getDisplayWeek(fromDate)

    const actions = [
      {
        ident: 'previous',
        icon: 'arrow-left',
        tooltip: 'task.form.tipPreviousweek',
        tooltipPosition: 'bottomleft',
        onClick: this._onHeaderNavigateWeek.bind(this, -1)
      },
      {
        ident: 'next',
        icon: 'arrow-right',
        tooltip: 'task.form.tipNextweek',
        tooltipPosition: 'bottom',
        onClick: this._onHeaderNavigateWeek.bind(this, 1)
      },
      {
        ident: 'date',
        icon: 'planner',
        tooltip: 'task.form.tipDatePick',
        tooltipPosition: 'bottom',
        onClick: this._onHeaderCalendarOpen.bind(this)
      }
    ]

    const statInfos = []
    const statDays = stat && stat.days ? stat.days : []
    statDays.forEach(day => {
      day.date = new Date(day.date)
      statInfos.push({
        title: `${DateUtil.getDisplayWeekDay(day.date).substr(
          0,
          3
        )} ${day.date.getDate()} ${DateUtil.getDisplayMonth(day.date)}`,
        isMultilingual: false,
        options: [
          {
            type: 'number',
            value: day.task || 0,
            active: true
          },
          {
            type: 'label',
            value: IntlUtil.convertMessage('task.list.labelTasks')
          }
        ],
        active: DateUtil.isDateEqual(day.date, this.activeDate),
        onClick: this._onHeaderChangeCurrentWeekDate.bind(
          this,
          new Date(day.date)
        )
      })
    })

    return (
      <div className='pagetask-headerwrap'>
        <PageHeaderTask
          title={`${IntlUtil.convertMessage('task.list.weekTitle')} ${weekNo}`}
          subtitle={`${IntlUtil.convertMessage(
            'time.list.labelFrom'
          )} ${DateUtil.getDisplayDate(fromDate)}
            ${IntlUtil.convertMessage(
              'time.list.labelTo'
            )} ${DateUtil.getDisplayDate(toDate)}`}
          icon={<TasksIcon width={25} />}
          isTitleMultilingual={false}
          hideUserLabel
          hideTaskIndicator
          statInfos={statInfos}
          alignStatInfos='bottom'
          actions={actions}
          alignActions='left'
          onSearchTags={this._onHeaderSearchTags.bind(this)}
          onChange={this._onHeaderChangeFilter.bind(this)}
        />
        <DateRangePicker
          ref={this._references.pageHeaderCalendar}
          placeholder='time.header.calendar'
          name='date'
          isSingleDate
          startDate={this.activeDate}
          endDate={null}
          onSelect={this._onHeaderChangeDate.bind(this)}
        />
      </div>
    )
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'member') {
      this._onSearchMember(keyword, callback)
    }
  }

  _onSearchMember (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          $or: [
            { firstName: { $regex: pattern, $options: 'i' } },
            { lastName: { $regex: pattern, $options: 'i' } }
          ],
          $select: ['userId', 'firstName', 'lastName'],
          status: 'active'
        }
      }
      params.query.teamId = app.getTeamId()

      app
        .service('/api/users/team')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(user => ({
              label: user.displayName,
              value: user.userId
            }))
            callback(options)
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug('PageTime: _onSearchMember err', err)
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderNavigateWeek (incr) {
    this._calculateFromToDates(
      DateUtil.addDaysToDate(this.activeDate, incr * 7)
    )

    this._reloadData()
  }

  _onHeaderCalendarOpen () {
    if (this._references.pageHeaderCalendar.current) {
      this._references.pageHeaderCalendar.current.show()
    }
  }

  _onHeaderChangeDate (date) {
    this._calculateFromToDates(date)

    this._reloadData()
  }

  _onHeaderChangeCurrentWeekDate (date) {
    this._calculateFromToDates(date)

    this._getDataTasks((err, _res) => {
      this._onDataReceived(err)
    })
  }

  /* Header Functions - END */
}

export default PlannerPageProvider(PageTaskMain)
